import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m6 6 36 36m-8-22v-4c0-5.523-4.477-10-10-10a9.953 9.953 0 0 0-5.292 1.514m-4.54 6.653C14.058 14.76 14 15.374 14 16v4.058m0 0c-1.177.071-2.011.233-2.724.596a6 6 0 0 0-2.622 2.622C8 24.56 8 26.24 8 29.6v2.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C12.56 42 14.24 42 17.6 42h12.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.399-2.222M14 20.058C14.943 20 16.105 20 17.6 20H20m20 8.805c-.004-2.839-.054-4.351-.654-5.529a5.999 5.999 0 0 0-2.622-2.622c-1.178-.6-2.69-.65-5.529-.654",
  stroke: "#fff",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };